<script setup lang="ts">
interface Props {
  search?: boolean
}
const { search } = defineProps<Props>()
const store = useStore()
const { filterLoading } = storeToRefs(store)
const categoryStore = useCategoryStore()
const { scrollLoading, url, scrollIndex } = storeToRefs(categoryStore)
const products = computed(() => categoryStore.productsData.elements)
const limit = computed(() => categoryStore.productsData.limit)
const total = computed(() => categoryStore.productsData.total)
const page = computed(() => categoryStore.productsData.page)
const maxPage = computed(() => Math.ceil(total.value / limit.value))
const { query, path } = useRoute()
const show = ref(false)
const scroll = ref({})
onMounted(() => {
  scrollIndex.value = 0
})
const loadData = async () => {
  scrollIndex.value += 1
  url.value = {
    'min-price': query['min-price'],
    'max-price': query['min-max'],
    properties: query.properties,
    order: query.order,
    p: page.value + scrollIndex.value,
    q: query.q
  }
  scrollLoading.value = true
  await categoryStore.loadFilter({ query: url.value, more: true, url: path, search })
  scrollLoading.value = false
  scrollData(products.value.length - 1, true)
}
const showMore = () => {
  show.value = true
  scrollData(limit.value - 1, false)
  loadData()
}
const getPage = async (id: string, add: number) => {
  if (total.value - 1 - ((page.value - 1) * limit.value) !== Number(id)) {
    const urlPage = (page.value - 1) + Math.ceil(Number(id)/limit.value) + add
    url.value = {
      'min-price': query['min-price'],
      'max-price': query['min-max'],
      properties: query.properties,
      order: query.order,
      p: urlPage !== 1 ? urlPage : undefined
    }
    await navigateTo({ path, query: url.value })
  }
}
const scrollData = (id: number, load: boolean) => {
  const el = document.querySelector(`li[data-index="${id}"]`)
  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0]
      if (load && entry.isIntersecting) {
        if (scrollIndex.value < maxPage.value - page.value) {
          loadData()
        }
      }
      const index = entry.target.dataset.index
      if (scroll.value.hasOwnProperty(index)) {
        if (scroll.value[index] < entry.boundingClientRect.top) {
          getPage(index, 0)
        } else {
          getPage(index, 1)
        }
      }
      scroll.value[index] = entry.boundingClientRect.top
  })
  if (el) {
    observer.observe(el)
  }
}
</script>

<template>
  <div>
    <div v-if="filterLoading" class="sticky top-0 z-10">
      <LoadingIndicator class="w-[100px] h-[100px] absolute top-[200px] left-1/2 -translate-x-1/2" />
    </div>
    <ul :class="{ 'opacity-30': filterLoading, 'md:after:w-[calc(100%/4-10px)]': products.length % 4 === 3 }" class="flex flex-wrap justify-center md:justify-between gap-[10px] after:max-w-[262px] md:after:max-w-full after:w-[calc(100%/2-10px)]">
      <li v-for="(p, index) in products" :key="p.id" class="group w-[calc(50%-5px)] md:w-[calc(25%-10px)] max-w-[262px]" :data-index="index">
        <ProductListItem :products="p" class="mb-[30px]" />
      </li>
    </ul>
    <div v-if="!show && page < maxPage" class="btn btn-secondary md:max-w-[336px] mx-auto my-[15px]" @click="showMore()">
      <span>Pokaż więcej produktów</span>
      <i class="icon-arrow-button text-[10px] rotate-90" />
    </div>
    <ProductListPagination v-if="!show" :max-page="maxPage" :load="categoryStore.load" :search="search" />
    <div v-if="scrollLoading" class="flex justify-center">
      <LoadingIndicator class="w-[100px] h-[100px]" />
    </div>
  </div>
</template>
